import styled from '@emotion/styled'

const ArticleInfoArticleWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`

export default ArticleInfoArticleWrapper